// extracted by mini-css-extract-plugin
export default {"wrapper":"GamesSectionHeader_wrapper--b0h","title":"GamesSectionHeader_title--trK","link":"GamesSectionHeader_link--_2I","icon":"GamesSectionHeader_icon--vm6"};